import { useMutation,useQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'
import {
  friendInviteList,
  getInviteAPI,
  joinWaitList,
  postCouponAPI,
  verifyInviteOTP,
  resendOTP,
} from '../api/inviteApi'
import { getDeviceId } from '../utils/helper'

export const useFetchInviteAPI = (options = {}) => {
  const deviceId = getDeviceId()

  return useQuery({
    queryKey: ['INVITE_TOKEN', deviceId],
    queryFn: async () => {
      try {
        const response = await getInviteAPI()
        return response
      } catch (error) {
        const status = error?.response?.status

        if (status === 422 || status === 404 || status === 405) {
          return {
            success: false,
            error: {
              message: 'device_not_invited'
            }
          }
        }

        throw error
      }
    },
    enabled: !!deviceId,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...options
  })
}

export const usePostCouponInviteAPI = (options = {}) => {
  const deviceId = getDeviceId()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ couponId }) => postCouponAPI({ deviceId, couponId }),
    onSuccess:()=>{
      queryClient.invalidateQueries(['INVITE_TOKEN'])
    },
    ...options
  })
}

export const usePostJoinWaitList = (options = {}) => {
  const deviceId = getDeviceId()
  return useMutation({
    mutationFn: ({ email, name, mobile, callingCode }) =>
      joinWaitList({
        deviceId,
        email,
        name,
        mobile,
        callingCode
      }),
    ...options
  })
}

export const usePostVerifyOTP = (options = {}) => {
  return useMutation({
    mutationFn: ({ email, otpValue, mobile, callingCode ,isWaitList}) =>
      verifyInviteOTP({ email, otpValue, mobile, callingCode,isWaitList }),
    ...options
  })
}

export const usePostResendOTP = (options = {}) => {
  return useMutation({
    mutationFn: ({ email, mobile, callingCode }) => resendOTP({ email, mobile, callingCode }),
    ...options
  })
}
// export const usePostFriendInviteList = (options = {}) => {
//   return useMutation({
//     mutationFn: (emailList) => friendInviteList(emailList),
//     ...options
//   })
// }

export const usePostFriendInviteList = (options = {}) => {
  return useMutation({
    mutationFn: (list) => friendInviteList(list),
    ...options
  })
}
